import { defineStore } from "pinia";

interface CategoriesState {
  categories: object[];
  live: object[];
  featured: any[];
  language: string;
}

export const CategoriesStore = defineStore({
  id: "categoriesStore",
  state: (): CategoriesState => ({
    categories: [],
    live: [],
    featured: [],
    language: "es",
  }),
  actions: {
    setFeatured(featured: any) {
      this.featured = Array.isArray(featured)
        ? featured
        : featured !== undefined && featured !== null
          ? [featured]
          : [];
    },
    setCategories(categories: object[], lang: string) {
      this.language = lang;
      // @ts-ignore
      this.categories = categories;
    },
    setLive(live: object[]) {
      // @ts-ignore
      this.live = live;
    },
  },
  getters: {
    getLive(): object[] {
      // @ts-ignore
      return this.live;
    },
    getLanguage(): string | null {
      return this.language;
    },
    getCategories(): object[] {
      // @ts-ignore
      return this.categories;
    },
    getFeatured(): any[] {
      return Array.isArray(this.featured) ? this.featured : [];
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "flxCategories",
        storage: localStorage,
      },
    ],
  },
});
